module.exports = __webpack_public_path__ + "img/三和兴.b5c24279.jpg";